/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appSageIntacct_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly sageIntacctEnabled: boolean | null;
        readonly workatoCustomerId: string | null;
        readonly workatoForecastSageIntacctConnectionId: string | null;
        readonly workatoSageIntacctConnectionId: string | null;
        readonly workatoIframeToken: string | null;
        readonly sageIntacctTimeRegsFromForecast: boolean | null;
        readonly sageIntacctSyncOnlyApproved: boolean | null;
    } | null;
    readonly " $refType": "appSageIntacct_viewer";
};
export type appSageIntacct_viewer$data = appSageIntacct_viewer;
export type appSageIntacct_viewer$key = {
    readonly " $data"?: appSageIntacct_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appSageIntacct_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appSageIntacct_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoCustomerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoForecastSageIntacctConnectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoSageIntacctConnectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoIframeToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctTimeRegsFromForecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctSyncOnlyApproved",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '8eec676717a3bdaf75f90c2bdb0b743b';
export default node;
